import { NameOption } from './name'
import { LimitBreachedOption } from './limit-breached'
import { WorkspaceStatusOption } from './workspace-status'
import { SubscriptionStatusOption } from './subscription-status'
import { SubscriptionPlanOption } from './subscription-plan'
import { DiscountedOption } from './discounted'
import { OfferOption } from './offer-request'
import { CancelOption } from './cancel-request'
import { HealthScore } from './health-score'
import { AgencyOption } from './agency'
import { SegmentOption } from './segment'

export const options = [
	NameOption,
	WorkspaceStatusOption,
	SubscriptionStatusOption,
	SubscriptionPlanOption,
	CancelOption,
	OfferOption,
	LimitBreachedOption,
	DiscountedOption,
	HealthScore,
	AgencyOption,
	SegmentOption
]
